export default class ClientsIndex {

  constructor() {}

  render() {
    const accountUrl = $('body').attr('data-account-url');

    // Reload with attrs
    let reloadWithSelectedParams = function() {
      let url = '/' + accountUrl + '/clients';
      let params = {};
      let clientType = $('#clients_table').attr('data-filters-client-type');
      let owner = $('#clients_table').attr('data-filters-owner');
      if (typeof clientType !== 'undefined') {params['client_type'] = clientType}
      if (typeof owner !== 'undefined') {params['owner'] = owner}
      Turbo.visit(url + '?' + $.param(params));
    }

    // On filter select
    $('#search_client_types').bind('typeahead:beforeselect typeahead:autocomplete', function(ev, suggestion) {
      ev.preventDefault();
      $('.tooltip').tooltip('hide');
      $('#clients_table').attr('data-filters-client-type', suggestion);
      reloadWithSelectedParams();
      $(this).blur();
    });

    // On filter select
    $('#search_account_members').bind('typeahead:beforeselect typeahead:autocomplete', function(ev, suggestion) {
      ev.preventDefault();
      $('.tooltip').tooltip('hide');
      $('#clients_table').attr('data-filters-owner', suggestion);
      reloadWithSelectedParams();
      $(this).blur();
    });

  }


}